<template>

  <section class="section">
    <div class="d-flex justify-content-between align-items-center mb-3" style="background:#e9ecef;">
      <b-breadcrumb class="m-0" :items="[
          { text: 'Clienti', to: '/customers' }
          ]">
      </b-breadcrumb>
      <input class="mr-3" placeholder="Cerca" type="text" v-model="searchTerm" >
    </div>
    <div>
        <router-link to="/customers/new" class="btn btn-primary">
        <font-awesome-icon icon="plus" />
        Nuovo cliente</router-link>
    </div>
    <div>
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :search-options="{
        enabled: true,
        externalQuery: searchTerm
        }">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'action'">
                <router-link class="" :to="'/customers/'+ props.row.guid">
                  <font-awesome-icon icon="cogs" />
                </router-link>
            </span>
            <template v-else-if="props.column.field == 'licenseExpire'">
              {{ formatDate(props.row.licenseExpire) }}
            </template>
            <template v-else>
              {{ props.row[props.column.field] }}
            </template>
          </template>
      </vue-good-table>
    </div>
    <!--
    <div class="row">
      <div class="col col-xs-12">
        <div class="card">
          <div class="card-block">
              <section>
                <table class="table striped table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Azienda</th>
                      <th>E-mail</th>
                      <th>Telefono</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-bind:key="model.id"  v-for="model in customers">
                      <td>
                        <router-link class="" :to="'/customers/'+ model.guid">
                          <font-awesome-icon icon="cogs" />
                        </router-link>
                      </td>
                      <td>{{ model.companyName }}</td>
                      <td>{{ model.email }}</td>
                      <td>{{ model.phone }}</td>
                    </tr>
                  </tbody>
                </table>

                <div>
                  <router-link to="/customers/new" class="btn btn-primary-underline">
                  <font-awesome-icon icon="plus" />
                  Nuovo cliente</router-link>
              </div>
              </section>
          </div>
        </div>

        <b-btn variant="primary" to="/customers/new">
          <font-awesome-icon icon="plus" />
          Nuovo cliente</b-btn>
      </div>
    </div>
    -->
  </section>

</template>

<script>

import { mapState, mapActions } from 'vuex'
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import moment from 'moment';
export default {
  name: 'CustomerList',
  computed: mapState({
    customers: state => state.customers.all
  }),

  components: {
  VueGoodTable,
},
    data()
    {
       return {
         searchTerm: '',
         columns:[
          {
           label:'',
            field:'action',
            sortable: false
           },
           {
            label:'Azienda',
            field:'companyName'
           },
           {
            label:'Email',
            field:'email'
           },
           {
            label:'Scadenza licenza',
            field:'licenseExpire',
           },
         ],
         rows:[]
       }
    },
  created () {
    this.$store.dispatch('customers/list')
  },
  watch:
  {
    customers()
    {
      this.rows=this.customers;
    }
  },

  methods: {
    formatDate(date) {
      if(! date) {
        return null;
      }
      return moment(date).format('DD/MM/YYYY')
    },
    del(id) {
      this.$store.dispatch('models/delModel', id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Customers/List.vue